<template lang="pug">
  y-dialog(fill-height fluid v-model="showModal" scrollable transition="fade-transition" persistent max-width="600px")
    v-card
      v-card-title.h6.basic800--text {{ $t('tracking_parcel') }}
      v-divider.basic300
        v-row(no-gutters)
          v-col
            //- v-chip.my-auto(small filled :color="shipping.status | leadStatusColor")
            //-     div.white--text {{ shipping.status | leadStatusDisplay }}
          v-col.shrink
            v-btn.mr-n2(text icon @click="showModal = !showModal" height)
              v-icon(color="white" :size="24") mdi-close

      v-card-text.pa-0.text-center

        v-container
          div.h6.primary400--text.mt-2 {{ shipping.courier }}
          div.p1.primary500--text {{ shipping.tracking_id }}

          v-layout.my-6(v-if="isFetching")
            v-row.fill-height.ma-0(align='center' justify='center')
              v-progress-circular.ma-auto(:width="2" :size="50" color="primary" indeterminate)
          .timeline-layout(v-else)
            v-divider.mx-4.mt-4
            v-timeline.text-left(dense clipped)
              template(v-for="history in histories")

                .created(v-if="history.group == 'created'")
                  v-timeline-item(color='success500' small)
                    v-col.pa-0
                      div.p1.primary500--text {{ history.event }}
                      div.c1.primary400--text {{ history.datetime | convertServerDate }}

                .transaction(v-else-if="history.group == 'transaction'")
                  v-timeline-item(fill-dot color='primary')
                    template(v-slot:icon='')
                      intel-avatar(:code="lead.member.user.avatar_code" :id="lead.member.user.id" size=48)
                    v-col.pa-0
                      div.p1.primary500--text {{ history.event }}
                      div.c1.primary400--text {{ history.datetime | convertServerDate }}

                .received(v-else-if="history.group == 'received'")
                  v-timeline-item(fill-dot color='accent' icon="mdi-package-variant-closed")
                    v-col.pa-0
                      div.p1.primary500--text {{ $t('order_received') }}.
                        strong Yezza!
                      div.c1.primary400--text {{ history.datetime | convertServerDate }}

                .others(v-else)
                  v-timeline-item(color='grey' small)
                    v-col.pa-0
                      div.p1.primary500--text {{ history.event }}
                      div.c1.primary400--text {{ history.datetime | convertServerDate }}

            v-divider.mx-4.mb-4

      v-card-actions
        v-spacer
        v-btn(color='white', text @click='showModal = false')
          .button-AA-small.primary400--text {{ $t('close') }}

</template>

<script>
import IntelAvatar from '@/components/IntelAvatar.vue'

export default {
  name: 'ParcelHistoryDialog',
  props: ['open', 'lead', 'shipping'],
  components: { IntelAvatar },
  data: () => ({
    isFetching: true,
    histories: []
  }),
  computed: {
    showModal: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    }
  },
  mounted () {
    this.fetchHistory()
  },
  methods: {
    async fetchHistory() {
      await this.axios.post(`/shipping/shippings/${this.lead.shipping.id}/update-tracking`, {}).catch(() => {})
      this.$axios.get(`/leads/${this.lead.pid}/tracking`)
        .then(resp => {
          this.histories = resp.data
        })
        .catch(() => {})
        .finally(() => {
          this.isFetching = false
        })
    }
  }
}
</script>

<style scoped>
</style>

<i18n>
{
  "en": {
    "tracking_parcel": "Tracking Parcel",
    "order_received": "Order received"
  },
  "id": {
    "tracking_parcel": "Paket Pelacakan",
    "order_received": "Pesanan diterima"
  }
}
</i18n>